<template>
  <div class="products-page trash-page" dir="rtl">
    <div class="products-hero">
      <div>
        <p class="hero-kicker mb-1">دسته‌بندی‌ها</p>
        <h1 class="mb-0">سطل زباله</h1>
      </div>
      <div class="hero-side">
        <div class="hero-count">
          <strong>{{ formatNumber(items.length) }}</strong>
          <span>دسته حذف‌شده</span>
        </div>
        <div class="hero-badge"><b-icon icon="trash"></b-icon></div>
      </div>
    </div>

    <div class="products-toolbar">
      <div class="products-toolbar-actions">
        <router-link class="products-tool-btn trash-back-btn" :to="{ name: 'Category' }">
          <span>بازگشت به دسته‌بندی‌ها</span>
          <b-icon icon="arrow-left"></b-icon>
        </router-link>
      </div>
      <div class="products-filter-bar">
        <div class="trash-filter-row">
          <label class="products-filter-field trash-search-field">
            <span><b-icon icon="search"></b-icon> جستجو در سطل زباله</span>
            <input class="products-filter-input" v-model="searchInput" placeholder="نام یا slug..."
                   @keydown.enter.prevent="applySearchNow">
          </label>
          <button v-if="searchInput" type="button" class="products-more-btn" @click="clearSearch">
            <b-icon icon="x-lg"></b-icon>
            <span>پاک کردن</span>
          </button>
          <span v-if="query" class="trash-result-count">{{ formatNumber(filtered.length) }} نتیجه</span>
        </div>
      </div>
    </div>

    <div class="products-list-panel">
      <div v-if="loading" class="products-loading">
        <div class="spinner-border" role="status"></div>
        <p class="mb-0">در حال بارگذاری...</p>
      </div>

      <div v-else-if="!filtered.length" class="products-empty">
        <i class="bi bi-trash"></i>
        <p class="mb-0">{{ query ? 'دسته‌ای با این عبارت در سطل زباله نیست.' : 'سطل زباله خالی است.' }}</p>
        <router-link v-if="!query" class="products-empty-btn" :to="{ name: 'Category' }">بازگشت به دسته‌بندی‌ها</router-link>
      </div>

      <div v-else class="trash-list">
        <div v-for="item in filtered" :key="item.id" class="trash-row" :class="{ 'is-busy': busyId === item.id }">
          <span class="trash-row__thumb">
            <img v-if="item.image" :src="item.image" alt="">
            <b-icon v-else icon="tag"/>
          </span>
          <div class="trash-row__text">
            <div class="trash-row__name">
              <span v-for="(part, i) in highlight(item.name)" :key="i" :class="{ 'trash-hl': part.m }">{{ part.t }}</span>
            </div>
            <div class="trash-row__meta">
              <span dir="ltr">
                <span v-for="(part, i) in highlight(item.slug)" :key="i" :class="{ 'trash-hl': part.m }">{{ part.t }}</span>
              </span>
              <span v-if="parentName(item)" class="is-parent">زیرِ «{{ parentName(item) }}»</span>
              <span v-if="item.deleted_at">حذف: {{ formatDate(item.deleted_at) }}</span>
            </div>
          </div>
          <div class="trash-row__actions">
            <button type="button" class="trash-btn" :disabled="busyId !== null" @click="restore(item)">
              <b-spinner v-if="busyId === item.id && busyAction === 'restore'" small/>
              <b-icon v-else icon="arrow-counterclockwise"/>
              <span>بازگردانی</span>
            </button>
            <button type="button" class="trash-btn is-danger" :disabled="busyId !== null" @click="forceDelete(item)">
              <b-spinner v-if="busyId === item.id && busyAction === 'delete'" small/>
              <b-icon v-else icon="trash"/>
              <span>حذف دائمی</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";
import {normalizeCategories} from "./categoryTree";
import "../product/products-ui.css";
import "../trash-ui.css";

export default {
  name: "TrashCategoryItems",
  data() {
    return {
      loading: true,
      items: [],
      searchInput: '',
      query: '',
      searchTimer: null,
      busyId: null,
      busyAction: null,
    }
  },
  computed: {
    namesById() {
      const map = new Map()
      this.items.forEach(item => map.set(String(item.id), item.name))
      return map
    },
    filtered() {
      const q = this.query
      if (!q) return this.items
      return this.items.filter(item =>
          String(item.name || '').toLowerCase().indexOf(q) > -1 || String(item.slug || '').toLowerCase().indexOf(q) > -1)
    },
  },
  watch: {
    searchInput(value) {
      clearTimeout(this.searchTimer)
      this.searchTimer = setTimeout(() => {
        this.query = String(value || '').trim().toLowerCase()
      }, 180)
    },
  },
  methods: {
    formatNumber,
    formatDate(value) {
      const date = new Date(value)
      return isNaN(date.getTime()) ? value : date.toLocaleDateString('fa-IR')
    },
    parentName(item) {
      if (item.parent && item.parent.name) return item.parent.name
      if (item.parent_id === null || item.parent_id === undefined) return ''
      return this.namesById.get(String(item.parent_id)) || ''
    },
    highlight(text) {
      const value = text === null || text === undefined ? '' : String(text)
      const q = this.query
      if (!q || !value) return [{t: value, m: false}]
      const lower = value.toLowerCase()
      const parts = []
      let from = 0
      let index = lower.indexOf(q)
      while (index !== -1) {
        if (index > from) parts.push({t: value.slice(from, index), m: false})
        parts.push({t: value.slice(index, index + q.length), m: true})
        from = index + q.length
        index = lower.indexOf(q, from)
      }
      if (from < value.length) parts.push({t: value.slice(from), m: false})
      return parts
    },
    applySearchNow() {
      clearTimeout(this.searchTimer)
      this.query = String(this.searchInput || '').trim().toLowerCase()
    },
    clearSearch() {
      this.searchInput = ''
      this.applySearchNow()
    },
    async getItems() {
      this.loading = true
      try {
        const res = await this.$store.dispatch("Category/getTrashCategories")
        const data = res && res.data ? res.data.data : []
        this.items = normalizeCategories((data && data.data && !Array.isArray(data)) ? data.data : (data || []))
      } catch (e) {
        console.log(e)
        this.items = []
      } finally {
        this.loading = false
      }
    },
    removeLocal(item) {
      this.items = this.items.filter(row => row.id !== item.id)
    },
    // store actions toast on success; the list is updated locally (no reload)
    async restore(item) {
      if (!confirm(`دسته «${item.name}» بازگردانی شود؟`)) return
      this.busyId = item.id
      this.busyAction = 'restore'
      try {
        await this.$store.dispatch("Category/restoreCategory", item)
        this.removeLocal(item)
      } catch (e) {
        toast('خطا', 'بازگردانی انجام نشد.', 'danger')
      } finally {
        this.busyId = null
        this.busyAction = null
      }
    },
    async forceDelete(item) {
      if (!confirm(`دسته «${item.name}» برای همیشه حذف شود؟ این کار قابل بازگشت نیست.`)) return
      this.busyId = item.id
      this.busyAction = 'delete'
      try {
        await this.$store.dispatch("Category/forceDelete", item)
        this.removeLocal(item)
      } catch (e) {
        toast('خطا', 'حذف دائمی انجام نشد.', 'danger')
      } finally {
        this.busyId = null
        this.busyAction = null
      }
    },
  },
  mounted() {
    this.$store.commit("Category/setCategories", {});
    this.$store.commit("Category/setFilteredCategories", {});
    this.getItems()
  },
  beforeDestroy() {
    clearTimeout(this.searchTimer)
  },
};
</script>
